import React from 'react';
import { motion } from 'framer-motion';

const scrollItems = [
  {
    title: "Tuck-End Cartons (STE / RTE)",
    description: "Ideal for cosmetics, pharma, and FMCG products.",
    image: "/Images/markets/RTE).webp" 
  },
  {
    title: "Sleeve & Tray Boxes",
    description: "Ideal for cosmetics, pharma, and FMCG products.",
    image: "/Images/markets/Sleeve & Tray Boxes.webp"
  },
  {
    title: "Window Cartons",
    description: "Ideal for cosmetics, pharma, and FMCG products.",
    image: "/Images/markets/Window Cartons.webp"
  },
  {
    title: "Gable Boxes",
    description: "Ideal for cosmetics, pharma, and FMCG products.",
    image: "/Images/markets/Gable Boxes.webp"
  },
  {
    title: "Display & POP Cartons",
    description: "Ideal for cosmetics, pharma, and FMCG products.",
    image: "/Images/markets/Display & POP Cartons.webp"
  },
  {
    title: "Pillow Boxes",
    description: "Ideal for distinctive gift packaging.",
    image: "/Images/markets/Pillow Boxes.webp"
  },
  {
    title: "Auto-Lock Bottom Cartons",
    description: "Ideal for heavy items, quick assembly.",
    image: "/Images/markets/Auto-Lock Bottom  Cartons.webp"
  },
  {
    title: "Multi-Pack Carriers",
    description: "Sturdy carriers for multipacks.",
    image: "/Images/markets/Multi-Pack Carriers.webp"
  }
];

export const MarketScroll = () => {
  return (
    <section className="py-20 bg-background relative z-10">
      <div className="container mx-auto px-4">
        {/* Responsive Split Layout: Mobile Stack, Tablet 30/70, Desktop 40/60 */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 lg:gap-20">
          
          {/* Left Section - Sticky on Tablet+ */}
          <div className="w-full md:w-[30%] lg:w-[40%]">
            <div className="static md:sticky md:top-32">
              <motion.h2 
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="font-heading mb-6 font-bold text-[32px] leading-[40px] md:text-[52px] md:leading-[67.6px] text-black tracking-normal"
              >
                Type of Mono-carton we produce
              </motion.h2>
              
              <motion.p 
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="mb-8 max-w-xl font-instrument font-medium text-[16px] leading-[24px] md:text-[20px] md:leading-[31.2px] text-black tracking-normal"
              >
                From sleek tuck-end cartons to bold display and pillow boxes, we craft premium mono cartons with precision printing and flawless finishes that elevate brands across every retail shelf.
              </motion.p>

              <div className="flex flex-wrap gap-3">
                 {['High-Precision Printing', 'Foil Stamping', 'Embossing'].map((tag) => (
                   <button 
                     key={tag}
                     className="px-6 py-2 rounded-full transition-colors hover:bg-gray-50"
                     style={{
                       border: '0.9px solid #CCCCCC', // Specific border style
                       color: '#000000', // Assuming black text matches the theme
                       fontFamily: '"Instrument Sans", sans-serif'
                     }}
                   >
                      {tag}
                   </button>
                 ))}
              </div>
            </div>
          </div>

          {/* Right Section - Scrolling Content */}
          <div className="w-full md:w-[70%] lg:w-[60%] space-y-16">
            {scrollItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="flex flex-col md:flex-row items-center gap-8 group"
              >
                {/* Image Card - 50% width */}
                <div className="w-full md:w-1/2 flex items-center justify-center min-h-[300px]">
                  <motion.img
                    whileHover={{ scale: 1.05, rotate: 2 }}
                    transition={{ type: "spring", stiffness: 300 }}
                    src={item.image}
                    alt={item.title}
                    className="w-full h-auto object-contain max-h-[400px] rounded-3xl"
                  />
                </div>

                {/* Text Content - 50% width */}
                <div className="w-full md:w-1/2 px-4 md:px-0">
                   <h3 className="text-3xl font-heading text-black mb-4">{item.title}</h3>
                   <p className="text-gray-600 text-lg">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};
